<template lang="html">
  <div>
    <a @click.prevent="route()" class="btn-white"
      ><i class="fa fa-angle-left mr-2"></i>{{ text }}</a
    >
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "Volver",
    },
    name: {
      type: String,
      default: null,
    },
    params: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  methods: {
    route: function() {
      if (this.name) {
        this.$router.push({ name: this.name, params: this.params });
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>
